module.exports = __webpack_public_path__ + "static/media/22ESCWA24.3a021e1a.jpg";